<div class="configurationBannerHeader" (click)="toggleExpansion()">
  <label class="configurationBannerLabel">Cabinet Features</label>
  <span class="spacer"></span>
  <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
</div>
@if (!collapsed) {
  <div class="selectionsWrapper">
    <div class="configurationDetailRow">
      <span class="halfWidthConfigurationInput">
        @if (drainPanSelection) {
          <span>
            <label class="halfWidthInputLabel">Drain Pan:</label>
            <select class="halfWidthInputField" #drainPanInput
              [class.invalidConfigurationSelection]="isInvalidSelection(drainPanSelection.Name)"
              (change)="selectedValueChanged(drainPanSelection.Name, drainPanInput.value)"
              [value]="drainPanSelection.Value.toString()">
              @for (allowable of drainPanSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="drainPanSelection.Value && drainPanSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
      <span class="halfWidthConfigurationInput">
        @if (outsideAirBoxSelection) {
          <span>
            <label [class.invalidConfigurationSelection]="isInvalidSelection(outsideAirBoxSelection.Name)"
            for="outsideAirWallBoxInput" class="halfWidthInputLabel">Outside Air Box:</label>
            <input type="checkbox" class="checkboxInput" id="outsideAirWallBoxInput"
              #outsideAirWallBoxInput [checked]="'true' === outsideAirBoxSelection.Value"
              (change)="selectedValueChanged(outsideAirBoxSelection.Name, outsideAirWallBoxInput.checked.toString())">
          </span>
        }
      </span>
    </div>
    @if (pipingControlsSelection || insulatedRearExtensionSelection) {
      <div class="configurationDetailRow">
        <span class="halfWidthConfigurationInput">
          @if (pipingControlsSelection) {
            <span>
              <label class="halfWidthInputLabel">Piping/Controls:</label>
              <select class="halfWidthInputField" #pipingControlsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(pipingControlsSelection.Name)"
                (change)="selectedValueChanged(pipingControlsSelection.Name, pipingControlsInput.value)"
                [value]="pipingControlsSelection.Value.toString()">
                @for (allowable of pipingControlsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="pipingControlsSelection.Value && pipingControlsSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </span>
        <span class="halfWidthConfigurationInput">
          @if (insulatedRearExtensionSelection) {
            <span>
              <label [class.invalidConfigurationSelection]="isInvalidSelection(insulatedRearExtensionSelection.Name)"
              for="insulatedRearExtension" class="halfWidthInputLabel">Insulated Rear Extension:</label>
              <input type="checkbox" class="checkboxInput" id="insulatedRearExtension"
                #insulatedRearExtension [checked]="'true' === insulatedRearExtensionSelection.Value"
                (change)="selectedValueChanged(insulatedRearExtensionSelection.Name, insulatedRearExtension.checked.toString())">
            </span>
          }
        </span>
      </div>
    }
    <div class="configurationDetailRow">
      <span class="halfWidthConfigurationInput">
        @if (cabinetInsulationSelection) {
          <span>
            <label class="halfWidthInputLabel">Cabinet Insulation:</label>
            <select class="halfWidthInputField" #cabinetInsulationInput
              [class.invalidConfigurationSelection]="isInvalidSelection(cabinetInsulationSelection.Name)"
              (change)="selectedValueChanged(cabinetInsulationSelection.Name, cabinetInsulationInput.value)"
              [value]="cabinetInsulationSelection.Value.toString()">
              @for (allowable of cabinetInsulationSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="cabinetInsulationSelection.Value && cabinetInsulationSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
      <span class="halfWidthConfigurationInput">
        @if (tamperProofPanelSelection) {
          <span>
            <label [class.invalidConfigurationSelection]="isInvalidSelection(tamperProofPanelSelection.Name)"
            for="tamperProofPanelInput" class="halfWidthInputLabel">Tamper Proof Panel:</label>
            <input type="checkbox" class="checkboxInput" id="tamperProofPanelInput"
              #tamperProofPanelInput [checked]="'true' === tamperProofPanelSelection.Value"
              (change)="selectedValueChanged(tamperProofPanelSelection.Name, tamperProofPanelInput.checked.toString())">
          </span>
        }
      </span>
    </div>
    <div class="configurationDetailRow">
      <span class="halfWidthConfigurationInput">
        @if (cabinetMaterialSelection) {
          <span>
            <label class="halfWidthInputLabel">Cabinet Material:</label>
            <select class="halfWidthInputField" #cabinetMaterialInput
              [class.invalidConfigurationSelection]="isInvalidSelection(cabinetMaterialSelection.Name)"
              (change)="selectedValueChanged(cabinetMaterialSelection.Name, cabinetMaterialInput.value)"
              [value]="cabinetMaterialSelection.Value.toString()">
              @for (allowable of cabinetMaterialSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="cabinetMaterialSelection.Value && cabinetMaterialSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
      <span class="halfWidthConfigurationInput">
        @if (trimKitSelection) {
          <span>
            <label [class.invalidConfigurationSelection]="isInvalidSelection(trimKitSelection.Name)"
            for="trimKitInput" class="halfWidthInputLabel">Trim Kit:</label>
            <input type="checkbox" class="checkboxInput" id="trimKitInput"
              #trimKitInput [checked]="'true' === trimKitSelection.Value"
              (change)="selectedValueChanged(trimKitSelection.Name, trimKitInput.checked.toString())">
          </span>
        }
      </span>
    </div>
    <div class="configurationDetailRow">
      <span class="halfWidthConfigurationInput">
        @if (frontPanelInsulationSelection) {
          <span>
            <label class="halfWidthInputLabel">Front Panel Insulation:</label>
            <select class="halfWidthInputField" #frontPanelInput
              [class.invalidConfigurationSelection]="isInvalidSelection(frontPanelInsulationSelection.Name)"
              (change)="selectedValueChanged(frontPanelInsulationSelection.Name, frontPanelInput.value)"
              [value]="frontPanelInsulationSelection.Value.toString()">
              @for (allowable of frontPanelInsulationSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="frontPanelInsulationSelection.Value && frontPanelInsulationSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
      <span class="halfWidthConfigurationInput">
        @if (levelingLegsSelection) {
          <span>
            <label class="halfWidthInputLabel">Leveling Legs:</label>
            <select class="halfWidthInputField" #levelingLegsInput
              [class.invalidConfigurationSelection]="isInvalidSelection(levelingLegsSelection.Name)"
              (change)="selectedValueChanged(levelingLegsSelection.Name, levelingLegsInput.value)"
              [value]="levelingLegsSelection.Value.toString()">
              @for (allowable of levelingLegsSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="levelingLegsSelection.Value && levelingLegsSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
    </div>
    <div class="configurationDetailRow">
      <span class="halfWidthConfigurationInput">
        @if (rightExtensionSelection) {
          <span>
            <label class="halfWidthInputLabel">Right Extension (in):</label>
            <select class="halfWidthInputField" #rightExtensionInput
              [class.invalidConfigurationSelection]="isInvalidSelection(rightExtensionSelection.Name)"
              (change)="selectedValueChanged(rightExtensionSelection.Name, rightExtensionInput.value)"
              [value]="rightExtensionSelection.Value.toString()">
              @for (allowable of rightExtensionSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="rightExtensionSelection.Value && rightExtensionSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
      <span class="halfWidthConfigurationInput">
        @if (leftExtensionSelection) {
          <span>
            <label class="halfWidthInputLabel">Left Extension (in):</label>
            <select class="halfWidthInputField" #leftExtensionInput
              [class.invalidConfigurationSelection]="isInvalidSelection(leftExtensionSelection.Name)"
              (change)="selectedValueChanged(leftExtensionSelection.Name, leftExtensionInput.value)"
              [value]="leftExtensionSelection.Value.toString()">
              @for (allowable of leftExtensionSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="leftExtensionSelection.Value && leftExtensionSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
    </div>
    <div class="configurationDetailRow">
      <span class="halfWidthConfigurationInput">
        @if (extensionHeightSelection) {
          <span>
            <label class="halfWidthInputLabel">Extension Height (in):</label>
            <select class="halfWidthInputField" #extensionHeightInput
              [class.invalidConfigurationSelection]="isInvalidSelection(extensionHeightSelection.Name)"
              (change)="selectedValueChanged(extensionHeightSelection.Name, extensionHeightInput.value)"
              [value]="extensionHeightSelection.Value.toString()">
              @for (allowable of extensionHeightSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="extensionHeightSelection.Value && extensionHeightSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
      <span class="halfWidthConfigurationInput">
        @if (extensionDepthSelection) {
          <span>
            <label class="halfWidthInputLabel">Extension Depth (in):</label>
            <select class="halfWidthInputField" #extensionDepthInput
              [class.invalidConfigurationSelection]="isInvalidSelection(extensionDepthSelection.Name)"
              (change)="selectedValueChanged(extensionDepthSelection.Name, extensionDepthInput.value)"
              [value]="extensionDepthSelection.Value.toString()">
              @for (allowable of extensionDepthSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="extensionDepthSelection.Value && extensionDepthSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
    </div>
  </div>
}
